import { z } from "zod";
import { uuidSchema } from "./domain";
import { sitywebRequestSchema } from "./sityweb";

/**
 * The lead detail shows the request, never connector credentials or technical feed state.
 * From the attribution only where it came from: the click ID and the raw UTM stay in the record.
 */
export const leadSitywebRequestDtoSchema = sitywebRequestSchema
  .pick({
    code: true,
    businessName: true,
    category: true,
    location: true,
    description: true,
    photos: true,
    emailVerifiedAt: true,
    createdAt: true,
  })
  .extend({
    requestId: uuidSchema,
    whatsappConfirmedAt: z.string().datetime().nullable(),
    acquisition: z
      .object({
        source: z.enum(["google_ads", "sityweb"]),
        campaign: z.string().max(200).nullable(),
      })
      .strict(),
  })
  .strict();
export type LeadSitywebRequestDto = z.infer<typeof leadSitywebRequestDtoSchema>;
